import queryString from 'query-string'
import { ADDRESS_API_URL } from '../../constants'

export const getAddressSuggestions = (params: { [key: string]: string | boolean }) => {
  const queryParams = queryString.stringify(params)

  return fetch(`${ADDRESS_API_URL}?${queryParams}`).then((resp) => resp.json())
}
